module.exports = __webpack_public_path__ + "static/media/Shape.5788bd5f.svg";